export default __webpack_public_path__ + "static/media/lexus.f525f8b8.png";